import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";

function TotalPriceInput(props: any) {
  const { t } = useTranslation();
  const {
    id,
    value,
    required,
    disabled,
    readonly,
    onChange,
    placeholder,
    schema,
    formContext,
  } = props;

  // Estado local para manejar el valor del input
  const [inputValue, setInputValue] = useState(value);

  const { element, setElement } = formContext;

  // Crear una versión debounced de la función onChange
  const debouncedOnChange = useCallback(
    (value: any) => {
      const handler = setTimeout(() => {
        onChange(value);
      }, 500); // Espera 0.5 segundos antes de invocar onChange

      // Limpieza: Clear the timeout if the component is unmounted or the value changes
      return () => {
        clearTimeout(handler);
      };
    },
    [onChange] // Re-crear esta función si onChange cambia
  );

  // Efecto para manejar cambios en inputValue
  useEffect(() => {
    // Llama a la función debounced cada vez que inputValue cambie
    const handler = debouncedOnChange(inputValue);

    // Limpieza: asegúrate de limpiar el timeout si el componente se desmonta
    return () => {
      if (handler) handler();
    };
  }, [inputValue, debouncedOnChange]);

  useEffect(() => {
    let totalPrice = 0;
    if (
      element.price_per_day
    ) {
      let extraPrice = 0;
      element.extras.forEach((extra: any) => {
        extraPrice += extra.price * extra.quantity;
        if (extra.type === 1) {
          extraPrice *= element.days;
        }
      });

      totalPrice = element.price_per_day * element.days + extraPrice;            
    }
    setElement((prevElement: any) => ({
      ...prevElement,
      total_price: totalPrice,
    }));
  }, [
    element.days,
    element.price_per_day,
    element.extras,
  ]);

  // Efecto para manejar cambios externos en 'value' prop
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <>
      <br />
      <div className="h3">
      {Intl.NumberFormat('es-Es', { style: 'currency', currency: 'EUR' }).format(value)}
      </div>      
    </>
  );
}

export default TotalPriceInput;
